import _ from "lodash";

export function currentUserToken() {
  let currentUser = JSON.parse(localStorage.getItem("currentUser"));
  return _.get(currentUser, "data.attributes.authentication_token");
}
